/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalGeneralContactNotification } from '../models/ExternalGeneralContactNotification';
import type { ExternalNotificationContactUsNotification } from '../models/ExternalNotificationContactUsNotification';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NotificationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Send Notification
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public sendNotification(
        requestBody: (ExternalNotificationContactUsNotification | ExternalGeneralContactNotification),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/notifications/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }

}
